import React from "react";
import { Modal } from "antd";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import BimeMelatIcon from "../../assets/img/mellat-01.svg";
import {
  M1,
  M2,
  M3,
  M4,
  M5,
  M6,
  M7,
  M8,
  M9,
  M10,
} from "./modalCandidateDriver.styles";
const ModalCandidateDriver = ({ visible, setVisible, Data, func }) => {
  console.log("dadash", Data);
  const handleCancel = () => {
    setVisible(false);
  };
  const handleOk=()=>{
    func();
    handleCancel();
  }
  return (
    <div>
      {Data && (
        <Modal
          footer={null}
          closable={false}
          visible={visible}
          onCancel={handleCancel}
        >
          <M1>
            <M3>کرایه توافق شده</M3>
            <M2>{toSeperatedNum(toPersianNum(Data.agreed_price))} تومان</M2>
          </M1>
          <M1>
            <M3>حق بیمه</M3>
            <M2>
              {toSeperatedNum(toPersianNum(Data.insurance.calculated_charj))}{" "}
              تومان
            </M2>
          </M1>
          <M7>
            <div
              className="w-75"
              style={{ fontSize: "12px", textAlign: "justify" }}
            >
              {toPersianNum(Data.insurance.description)}
              <a
                href="https://barnet.app/mellatInsuranceTerms"
                target="_blank"
                className="text-primary"
              >
                توضیحات بیشتر
              </a>
            </div>
            <img
              src={BimeMelatIcon}
              alt="BimeMelaticn"
              style={{ width: "45px", marginLeft: " 5%" }}
            />
          </M7>

          <M4>
            مبلغ نهایی : {toSeperatedNum(toPersianNum(Data.final_payment))}{" "}
            تومان
          </M4>
          <M5>
            <M6>
              {" "}
              پیش پرداخت :{" "}
              {Data.pre_payed === 0
                ? "۰"
                : toSeperatedNum(toPersianNum(Data.pre_payed))}{" "}
              تومان
            </M6>
            <div style={{ fontSize: "12px", textAlign: "justify" }}>
              {Data.description}
            </div>
            <div
              style={{
                fontSize: "12px",
                textAlign: "justify",
                color: "#ed5565",
              }}
            >
              {Data.description_red}
            </div>
          </M5>
          <M8>
            <M10 onClick={handleCancel}>لفو</M10>
            <M9 onClick={handleOk}>تایید</M9>
          </M8>
        </Modal>
      )}
    </div>
  );
};

export default ModalCandidateDriver;
